import { Decimal } from 'decimal.js-light';
import { DECIMAL_DIGITS } from 'src/modules/common/constants.ts';

const hour = new Decimal(3600);

export const calcV100 = (
    ratedCapacityQ: string,
    temperatureChangeDT: string,
    specificHeatCapacityC: string,
    density: string,
) => {
    try {
        return new Decimal(ratedCapacityQ)
            .dividedBy(new Decimal(specificHeatCapacityC).mul(new Decimal(temperatureChangeDT)))
            .mul(hour)
            .dividedBy(new Decimal(density))
            .toFixed(DECIMAL_DIGITS);
    } catch {
        return '';
    }
};
